import { Flex, Spinner } from '@chakra-ui/react'

export const FullScreenLoader = () => (
  <Flex justifyContent='center' alignItems='center' style={{ height: '100vh' }}>
    <Spinner />
  </Flex>
)
